var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayJarFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 15.25V19.75C6.25 21.1307 5.13071 22.25 3.75 22.25C2.36929 22.25 1.25 21.1307 1.25 19.75V19.25",
    stroke: "#EB1919",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 9.25H11.25V2.25",
    stroke: "#EB1919",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 11.25V9.32843C4.25 8.79799 4.46071 8.28929 4.83579 7.91421L9.91421 2.83579C10.2893 2.46071 10.798 2.25 11.3284 2.25H18.25C19.3546 2.25 20.25 3.14543 20.25 4.25V11.25",
    stroke: "#EB1919",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82832 22.25H8.75L11.25 15.25H12.25L14.75 22.25H14.6648",
    stroke: "#EB1919",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 20.75H14.25",
    stroke: "#EB1919",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 19.25L21.0821 18.6953L20.7852 18.25H20.25V19.25ZM22.25 22.25V23.25H24.1185L23.0821 21.6953L22.25 22.25ZM22.0904 21.25H21.0904V23.25H22.0904V21.25ZM19.25 20.25H20.25V18.25H19.25V20.25ZM19.4179 19.8047L21.4179 22.8047L23.0821 21.6953L21.0821 18.6953L19.4179 19.8047ZM22.25 21.25H22.0904V23.25H22.25V21.25Z",
    fill: "#EB1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 22.25V15.25H20.25C21.3546 15.25 22.25 16.1454 22.25 17.25C22.25 18.3546 21.3546 19.25 20.25 19.25H18.25",
    stroke: "#EB1919",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayJarFile);
export default __webpack_public_path__ + "static/media/play-jar-file.79a211aab3c8de012ef35bedba29c21d.svg";
export { ForwardRef as ReactComponent };